export class UserPractices{
    UserId: number;
    PracticeId: number;
    AddedBy: string;
    DateAdded: Date;
    IsActive: boolean;
    ChangedBy: string;
    ChangedDate: Date;
    isL1: boolean;
    isL2: boolean;
}
